var render = function (_h,_vm) {var _c=_vm._c;return _c('h2',{staticClass:"mb-8 lg:mb-10 xl:mb-8 heading-5 md:heading-4",class:_vm.data.staticClass},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }